import { createTheme, adaptV4Theme } from '@mui/material';
import { ptBR } from '@mui/material/locale';

import palette from './palette';
import typography from './typography';
import overrides from './overrides';

const theme = createTheme(
  adaptV4Theme(
    {
      palette,
      typography,
      overrides,
      zIndex: {
        appBar: 1200,
        drawer: 1100,
      },
    },
    ptBR,
  ),
);

export default theme;
